import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { shopPrefix } from '../../config';
import { globalError, showNotification } from '../../store/notifications/actions';
import { http } from '../axios';
import { ProductMetaData } from '../../../models/Product';
import { Article } from '../../../models/Article';

export function useAddProductToGroup() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (productGroupId: string, product: ProductMetaData & Article) =>
        http
            .put(
                `${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/bulk/cc/ids/copy`,
                { productIds: [product.id] },
                { pathParams: { productGroupId } }
            )
            .then(() => {
                dispatch(
                    showNotification(
                        t('notifications.getMessageFromActionProductGroup.add', { productTitle: product.title })
                    )
                );
            })
            .catch(error => {
                dispatch(globalError(error));
            });
}
